(function() {
  'use strict';
  
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');
  
  if (!variantId) return;
  
  console.log('🔍 Trying to select variant:', variantId);
  
  function selectVariant() {
    // Get all variants data to find which color matches our variant ID
    const variantScript = document.querySelector('variant-selects script[type="application/json"]');
    
    if (!variantScript) {
      console.error('❌ Could not find variant data');
      return;
    }
    
    try {
      const variants = JSON.parse(variantScript.textContent);
      const matchingVariant = variants.find(v => v.id == variantId);
      
      if (!matchingVariant) {
        console.error('❌ Could not find variant:', variantId);
        return;
      }
      
      console.log('✅ Found matching variant:', matchingVariant);
      
      // Find which option contains the color (could be option1, option2, or option3)
      const colorValue = matchingVariant.option1 || matchingVariant.option2 || matchingVariant.option3;
      
      console.log('🎨 Looking for color:', colorValue);
      
      // Find and click the radio button for this color
      const colorRadios = document.querySelectorAll('input[type="radio"][name*="Color"]');
      
      colorRadios.forEach(radio => {
        if (radio.value === colorValue) {
          console.log('✅ Found matching radio button:', radio);
          
          // Check the radio button
          radio.checked = true;
          
          // Trigger change event
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Also click it to be sure
          radio.click();
          
          console.log('✅ Clicked color radio for:', colorValue);
        }
      });
      
      // Also update hidden inputs as backup
      const hiddenInputs = document.querySelectorAll('input[name="id"]');
      hiddenInputs.forEach(input => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      
    } catch (e) {
      console.error('❌ Error selecting variant:', e);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(selectVariant, 1000);
    });
  } else {
    setTimeout(selectVariant, 1000);
  }
})();